import { createRouter, createWebHistory } from "vue-router";
import api from "@/api"; // ← GANTI INI
import SelectName from "../pages/SelectName.vue";
import SelectTable from "../pages/SelectTable.vue";
import Ordertype from "@/pages/Ordertype.vue";
import MenuPage from "../pages/MenuPage.vue";
import CartPage from "@/pages/CartPage.vue";

const routes = [
  {
    path: "/",
    name: "Ordertype",
    component: Ordertype,
  },
  {
    path: "/name",
    name: "SelectName",
    component: SelectName,
    props: true,
    meta: { requiresCafeOpen: true },
  },
  {
    path: "/table",
    name: "SelectTable",
    component: SelectTable,
    props: true,
    meta: { requiresCafeOpen: true },
  },
  {
    path: "/menu/:hash/:tableId",
    name: "MenuPage",
    component: MenuPage,
    props: true,
    meta: { requiresCafeOpen: true },
  },
  {
    path: "/cart/:hash",
    name: "CartPage",
    component: CartPage,
    props: true,
    meta: { requiresCafeOpen: true },
  },
  {
    path: "/order/:hash",
    name: "OrderPage",
    component: () => import("@/pages/OrderPage.vue"),
    props: true,
    meta: { requiresCafeOpen: true },
  },
  {
    path: "/about",
    name: "AboutPage",
    component: () => import("@/pages/AboutPage.vue"),
  },
  {
    path: "/contact",
    name: "ContactPage",
    component: () => import("@/pages/ContactPage.vue"),
  },
  {
    path: "/closed",
    name: "CafeClosed",
    component: () => import("@/pages/CafeClosed.vue"),
  },
  {
    path: "/not-found",
    name: "NotFound",
    component: {
      template:
        '<div style="padding:2rem;text-align:center;font-size:2rem;">404 Not Found</div>',
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/not-found",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Clear cookies/localStorage if navigating to the root path
  if (to.path === "/") {
    localStorage.removeItem("orderType");
    localStorage.removeItem("customerName");
    localStorage.removeItem("tableNumber");
    localStorage.removeItem("sessionHash");
    localStorage.removeItem("cart");
    console.log("Cleared order-related localStorage items.");
  }

  try {
    const response = await api.get("/settings");
    const isCafeOpen = response.data && response.data.is_open === true;

    console.log("Cafe Status Check - is_open:", isCafeOpen, "Route:", to.name);

    // Jika cafe TUTUP (is_open = 0/false)
    if (!isCafeOpen) {
      // Jika user mencoba akses halaman selain CafeClosed, redirect ke CafeClosed
      if (
        to.name !== "CafeClosed" &&
        to.name !== "AboutPage" &&
        to.name !== "ContactPage"
      ) {
        console.log("Cafe closed! Redirecting to CafeClosed from", to.name);
        return next({ name: "CafeClosed", replace: true });
      }
    }
    // Jika cafe BUKA (is_open = 1/true)
    else {
      // Jika user refresh/akses CafeClosed saat cafe buka, redirect ke Ordertype
      if (to.name === "CafeClosed") {
        console.log("Cafe is open! Redirecting to Ordertype from CafeClosed");
        return next({ name: "Ordertype", replace: true });
      }

    }

    // Validasi untuk SelectName
    if (to.name === "SelectName") {
      const sessionHash = localStorage.getItem("sessionHash");
      const orderMode = localStorage.getItem("orderMode");

      if (!sessionHash || !orderMode) {
        console.log(
          "SelectName validation failed, redirecting to Ordertype"
        );
        return next({ name: "Ordertype", replace: true });
      }
    }

    // Validasi untuk SelectTable
    if (to.name === "SelectTable") {
      const sessionHash = localStorage.getItem("sessionHash");
      const orderMode = localStorage.getItem("orderMode");

      if (!sessionHash || !orderMode) {
        console.log(
          "SelectTable validation failed, redirecting to Ordertype"
        );
        return next({ name: "Ordertype", replace: true });
      }
    }

    // Validasi untuk MenuPage
    if (to.name === "MenuPage") {
      const hash = to.params.hash;
      const tableId = to.params.tableId;
      const sessionHash = localStorage.getItem("sessionHash");
      const localTable = localStorage.getItem("tableNumber");
      const orderMode = localStorage.getItem("orderMode");

      const isDineInValid = orderMode === "dine-in" && tableId === localTable;
      const isTakeawayValid = orderMode === "take-away" && tableId === "0";

      if (
        !hash ||
        hash !== sessionHash ||
        (!isDineInValid && !isTakeawayValid)
      ) {
        console.log("MenuPage validation failed");
        return next({ name: "NotFound", replace: true });
      }
    }

    // Validasi untuk CartPage & OrderPage
    if (to.name === "CartPage" || to.name === "OrderPage") {
      const hash = to.params.hash;
      const sessionHash = localStorage.getItem("sessionHash");

      if (!hash || hash !== sessionHash) {
        console.log(to.name, "validation failed");
        return next({ name: "NotFound", replace: true });
      }
    }
  } catch (error) {
    console.error("Error checking cafe status:", error);
    // Jika ada error fetching status, lanjutkan normal (assume cafe buka)
  }

  next();
});

// Stop loading animation setelah route selesai
router.afterEach(() => {
  if (typeof window !== "undefined" && window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent("route-loading", { detail: false }));
  }
});

// Stop loading animation jika ada error
router.onError(() => {
  if (typeof window !== "undefined" && window.dispatchEvent) {
    window.dispatchEvent(new CustomEvent("route-loading", { detail: false }));
  }
});

export default router;
